<script lang="ts">
  import { DropdownItem } from '$lib/components/common/dropdowns/dropdown';
  import type { PostFiltersSchema } from '$src/utils/api/feed.util';
  import Dropdown from '$lib/components/common/dropdowns/Dropdown.svelte';
  export let detail: PostFiltersSchema['projectDuration'] = {
    hoursGreaterThan: null,
    hoursLowerThan: null
  };
  export let isValid: boolean;

  const durationItems = [
    new DropdownItem({
      variant: 'label',
      data: { label: 'Less than an hour' },
      customData: { from: 0, to: 1 }
    }),
    new DropdownItem({
      variant: 'label',
      data: { label: '1 - 2 hours' },
      customData: { from: 1, to: 2 }
    }),
    new DropdownItem({
      variant: 'label',
      data: { label: '2 - 10 hours' },
      customData: { from: 2, to: 10 }
    }),
    new DropdownItem({
      variant: 'label',
      data: { label: '10 - 24 hours' },
      customData: { from: 10, to: 24 }
    }),
    new DropdownItem({
      variant: 'label',
      data: { label: '1 - 3 days' },
      customData: { from: 24, to: 72 }
    }),
    new DropdownItem({
      variant: 'label',
      data: { label: '3 - 7 days' },
      customData: { from: 72, to: 168 }
    }),
    new DropdownItem({
      variant: 'label',
      data: { label: '1 - 4 weeks' },
      customData: { from: 168, to: 672 }
    }),
    new DropdownItem({
      variant: 'label',
      data: { label: 'More than a month' },
      customData: { from: 672, to: null }
    })
  ];

  function handleDurationSelected(item) {
    detail = { hoursGreaterThan: item.customData.from, hoursLowerThan: item.customData.to };
  }

  $: isValid = detail.hoursGreaterThan !== null;
</script>

<Dropdown
  variant="border-selected-label-with-arrow"
  items={durationItems}
  label="Choose a duration"
  placeholder="Select"
  alignDropdown="start"
  caption="Choose a duration"
  variantOptions={{
    arrowColor: '#0F9D58',
    variant: 'border-selected-label-with-arrow'
  }}
  disablePadding
  on:itemSelected={e => handleDurationSelected(e.detail.item)}
/>
